<div class="price-calculator">
  @if (salesProductPrice$ | async; as salesProductPrice) {
    <form (ngSubmit)="onSubmit()" #priceForm="ngForm" autocomplete="off">
      <div class="form-group row">
        <label for="userCustomUvpPrice" class="col-form-label col-md-7">
          {{ 'priceCalculator.marginSellingPrice' | cxTranslate }}
        </label>
        <div class="col-md-5">
          <input type="text" id="userCustomUvpPrice" class="form-control" [(ngModel)]="userCustomUvpPrice"
            name="userCustomUvpPrice" [readonly]="!editOwnVkUser" (input)="onChangeInput(0)" />
          </div>
        </div>
        <div class="form-group row">
          <label for="userCustomProfitMarginPercent" class="col-form-label col-md-7">
            {{ 'priceCalculator.margin' | cxTranslate }}
          </label>
          <div class="col-md-5">
            <input type="text" id="userCustomProfitMarginPercent" class="form-control"
              [(ngModel)]="userCustomProfitMarginPercent" name="userCustomProfitMarginPercent" [readonly]="!editOwnVkUser"
              (input)="onChangeInput(1)" />
            </div>
          </div>
          <div class="row price-calculator-action">
            <div class="col-md-7">
            </div>
            <div class="col-md-5">
              @if (editOwnVkUser) {
                <button class="btn btn-primary btn-block" type="submit">
                  {{ 'priceCalculator.submit' | cxTranslate }}
                </button>
              }
            </div>
          </div>
        </form>
      } @else {
        <cx-spinner></cx-spinner>
      }
    </div>
